
module.exports = {
  // TODO: change your profile information here
  name: "Sujal Agrawal",
  greeting: "Hey 👋",
  greetingDescription: "I'm Sujal Agrawal and I'm a Software Engineer!",
  githubUrl: "https://github.com/Sujal-Agrawal",
  linkedinUrl: "https://www.linkedin.com/in/sujal-agrawal-7345221a5/",
  cvLink: "https://drive.google.com/file/d/1Ye5LKiLe6sj9K9KFlDCPkxwpQOb7nNfN/view?usp=sharing",
};
